import { useState } from 'react';
import LoginPage from './LoginPage';
import Dashboard from './Dashboard';
import AdminPage from './AdminPage';

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('uam_user');
    if (!localStorage.getItem('token') || !saved) return null;
    return JSON.parse(saved);
  });
  const [page, setPage] = useState(() => sessionStorage.getItem('uam_page') || 'dashboard');

  function navigate(p) {
    sessionStorage.setItem('uam_page', p);
    setPage(p);
  }

  function handleLogin(userInfo) {
    localStorage.setItem('uam_user', JSON.stringify(userInfo));
    setUser(userInfo);
    navigate('dashboard');
  }

  function handleLogout() {
    localStorage.removeItem('token');
    localStorage.removeItem('uam_user');
    sessionStorage.removeItem('uam_page');
    setUser(null);
    setPage('dashboard');
  }

  const goHome = () => navigate('dashboard');

  if (!user) return <LoginPage onLogin={handleLogin} />;
  if (page === 'admin') return <AdminPage session={user} onLogout={handleLogout} onBack={goHome} onHome={goHome} />;
  return <Dashboard session={user} onLogout={handleLogout} onAdminClick={() => navigate('admin')} onHome={goHome} />;
}

export default App;
